<template>
  <div>
    <vxe-grid
      size="small"
      row-id="colorCode"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayStatus="{ row }">
        <el-tag
          size="small"
          :type="
            row.versionStatus === 'Y'
              ? 'success'
              : row.versionStatus === 'N'
              ? 'primary'
              : row.versionStatus === 'F'
              ? 'warning'
              : 'danger'
          "
        >
          {{ row.versionStatusText }}
        </el-tag>
      </template>
      <template v-slot:forceUpdate="{ row }">
        <el-tag
          size="small"
          :type="row.forceUpdate === 'Y' ? 'primary' : 'warning'"
        >
          {{ row.forceUpdateText }}
        </el-tag>
      </template>
      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditDialog', {
            type: menuType,
            versionCode: data.versionCode,
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'uploadFilled':
          this.uploadFilled(data)
          break
        case 'rollback':
          this.rollback(data)
          break
        case 'viewQrCode':
          this.$emit('viewQrCode', data)
          break
      }
    },

    async del({ versionNo, versionCode }) {
      const confirm = await this.$confirm(
        `确认要删除当前版本【${versionNo}】吗？`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .appVersionRecordsDelApi({ versionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },

    async uploadFilled({ versionNo, versionCode }) {
      const confirm = await this.$confirm(
        `确认要发布当前版本【${versionNo}】吗？`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .appVersionRecordsReleaseApi({ versionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      const isWarning = status !== 200
      this.$message({ message: msg, type: isWarning ? 'warning' : 'success' })
      if (isWarning) return
      this.$emit('reload')
    },
    async rollback({ versionNo, versionCode }) {
      const confirm = await this.$confirm(
        `确认要回退到当前版本【${versionNo}】吗？`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .appVersionRecordsRollbackApi({ versionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      const isWarning = status !== 200
      this.$message({ message: msg, type: isWarning ? 'warning' : 'success' })
      if (isWarning) return
      this.$emit('reload')
    },
  },
}
</script>
